export default __webpack_public_path__ + "static/media/Helping_Our_Own_Brookshire_Brothers.3f4e2452.pdf";